// extracted by mini-css-extract-plugin
export default {"page":"upc-support-page_page__Fbb6K","footer":"upc-support-page_footer__jLGqW","component":"upc-support-page_component__zr6zf","logo":"upc-support-page_logo__zqoZL"};